import {
  type HostExample,
  StringList,
  type UrlExample,
  validateEnv,
} from '@devhacker/shared/utils/validateEnv';

type PathNameExample = '/example/test';
type YaMetricId = 'XXXXXXX';

// API
export const API_URL = validateEnv<UrlExample>({
  name: 'API_URL',
  value: import.meta.env.VITE_API_URL,
  type: String,
});

export const QUIZ_API_URL = validateEnv<UrlExample>({
  name: 'QUIZ_API_URL',
  value: import.meta.env.VITE_QUIZ_API_URL,
  type: String,
});

export const API_REACTIONS_URL = validateEnv<UrlExample>({
  name: 'API_REACTIONS_URL',
  value: import.meta.env.VITE_API_REACTIONS_URL,
  type: String,
});

export const AUTH_API_URL = validateEnv<UrlExample>({
  name: 'AUTH_API_URL',
  value: import.meta.env.VITE_AUTH_API_URL,
  type: String,
});

export const PROFILE_API_URL = validateEnv<UrlExample>({
  name: 'PROFILE_API_URL',
  value: import.meta.env.VITE_PROFILE_API_URL,
  type: String,
});

export const AUTH_CLIENT_ID = validateEnv({
  name: 'AUTH_CLIENT_ID',
  value: import.meta.env.VITE_AUTH_CLIENT_ID,
  type: String,
  fallback: 'web',
});

export const PUSHER_API_URL = validateEnv({
  name: 'PUSHER_API_URL',
  value: import.meta.env.VITE_PUSHER_API_URL,
  type: String,
});

export const API_URL_PREFIX = validateEnv<PathNameExample>({
  name: 'API_URL_PREFIX',
  value: import.meta.env.VITE_API_URL_PREFIX,
  type: String,
});

export const TALKER_API_URL = validateEnv<UrlExample>({
  name: 'TALKER_API_URL',
  value: import.meta.env.VITE_TALKER_API_URL,
  type: String,
});

export const API_ADMIN_ACTIONS = validateEnv<UrlExample>({
  name: 'API_ADMIN_ACTIONS',
  value: import.meta.env.VITE_API_ADMIN_ACTIONS,
  type: String,
});

export const HOME_URL = validateEnv<UrlExample>({
  name: 'HOME_URL',
  value: import.meta.env.VITE_HOME_URL,
  type: String,
});

export const API_TIMEOUT = 20000;

// COOKIE
export const ACCESS_TOKEN_COOKIE_NAME = validateEnv({
  name: 'ACCESS_TOKEN_COOKIE_NAME',
  value: import.meta.env.VITE_ACCESS_TOKEN_COOKIE_NAME,
  type: String,
});

export const ACCESS_TOKEN_COOKIE_DOMAIN = validateEnv<HostExample>({
  name: 'ACCESS_TOKEN_COOKIE_DOMAIN',
  value: import.meta.env.VITE_ACCESS_TOKEN_COOKIE_DOMAIN,
  type: String,
});

export const YA_METRIC_ID = validateEnv<HostExample>({
  name: 'YA_METRIC_ID',
  value: import.meta.env.VITE_YA_METRIC_ID,
  type: String,
});

export const YA_METRIK_IDS_AMP = validateEnv<YaMetricId[]>({
  name: 'YA_METRIK_IDS_AMP',
  value: import.meta.env.VITE_YA_METRIK_IDS_AMP,
  type: StringList,
});

// CACHE
export const REDIS_SSR_CACHE_HTTP_TOKEN = validateEnv({
  name: 'REDIS_SSR_CACHE_HTTP_TOKEN',
  value: process.env.REDIS_SSR_CACHE_HTTP_TOKEN,
  type: String,
  fallback: import.meta.server ? undefined : '',
});

export const REDIS_SSR_CACHE = validateEnv({
  name: 'REDIS_SSR_CACHE',
  value: process.env.REDIS_SSR_CACHE,
  type: Boolean,
  fallback: import.meta.server ? undefined : false,
});

export const REDIS_APP_CACHE = validateEnv({
  name: 'REDIS_APP_CACHE',
  value: process.env.REDIS_APP_CACHE,
  type: Boolean,
  fallback: import.meta.server ? undefined : false,
});

export const SENTRY_SERVER_DNS = validateEnv({
  name: 'SENTRY_SERVER_DNS',
  value: process.env.SENTRY_SERVER_DNS,
  type: String,
  fallback: '',
});

export const SENTRY_CLIENT_DNS = validateEnv({
  name: 'SENTRY_CLIENT_DNS',
  value: import.meta.env.VITE_SENTRY_CLIENT_DNS,
  type: String,
  fallback: '',
});
